import React, { useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { VideoSection } from '../components/VideoSection';
import { AnxietyTest } from '../components/AnxietyTest';
import { OfferSection } from '../components/OfferSection';
import { ProblemSection } from '../components/ProblemSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { DetailsSection } from '../components/DetailsSection';
import { SpiritualBackground } from '../components/SpiritualBackground';
import { LegalModal } from '../components/LegalModal';
import { ChatWidget } from '../components/ChatWidget';
export function SalesPage() {
  const [legalModal, setLegalModal] = useState<{
    open: boolean;
    tab: 'terms' | 'privacy';
  }>({
    open: false,
    tab: 'terms'
  });
  return <main className="font-sans antialiased min-h-screen relative bg-[#F7F7F5]" data-id="element-330">
      <SpiritualBackground data-id="element-331" />

      <div className="relative z-10" data-id="element-332">
        {/* 1. Logo del producto */}
        <HeroSection data-id="element-333" />

        {/* 2. Video */}
        <VideoSection data-id="element-334" />

        {/* 3. Test de ansiedad */}
        <AnxietyTest data-id="element-335" />

        {/* 4. Botón de compra */}
        <OfferSection data-id="element-336" />

        {/* Supporting Sections */}
        <ProblemSection data-id="element-337" />
        <ProtocolSection data-id="element-338" />
        <DetailsSection data-id="element-339" />

        <footer className="bg-transparent text-[#7A7A7A] py-12 text-center text-sm space-y-4" data-id="element-340">
          <div className="flex items-center justify-center gap-4" data-id="element-341">
            <button onClick={() => setLegalModal({
            open: true,
            tab: 'terms'
          })} className="hover:text-[#5BBFB5] transition-colors font-medium" data-id="element-342">
              Términos y Condiciones
            </button>
            <span className="text-[#E8E8E6]" data-id="element-343">•</span>
            <button onClick={() => setLegalModal({
            open: true,
            tab: 'privacy'
          })} className="hover:text-[#5BBFB5] transition-colors font-medium" data-id="element-344">
              Política de Privacidad
            </button>
          </div>
          <p className="font-light" data-id="element-345">
            &copy; {new Date().getFullYear()} Ansiedad Exprés. Todos los
            derechos reservados.
          </p>
        </footer>
      </div>

      <LegalModal isOpen={legalModal.open} onClose={() => setLegalModal({
      ...legalModal,
      open: false
    })} initialTab={legalModal.tab} data-id="element-346" />

      <ChatWidget data-id="element-347" />
    </main>;
}